<template>
  <div class="pause-controller">
    <font-awesome-icon
      @click="stopGame"
      icon="pause"
      class="user-action-button"
      :class="{active: !isPaused}"
    />
    <font-awesome-icon
      @click="restartGame"
      icon="play"
      class="user-action-button"
      :class="{active: isPaused}"
    />
    <div class="now-pausing" v-if="isPaused">停止中</div>
  </div>
</template>

<script>
export default {
  name: 'PauseController',
  computed: {
    isPaused() {
      return this.$store.state.game.stop;
    },
  },
  methods: {
    stopGame() {
      this.$store.dispatch('setUserActionMode', { mode: null });
      this.$store.dispatch('stopGame');
    },
    restartGame() {
      this.$store.dispatch('restartGame');
    },
  },
};
</script>

<style lang="scss" scoped>
.pause-controller {
  .user-action-button {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.active {
      display: block;
    }
  }

  .now-pausing {
    position: absolute;
    left: 50%;
    top: -2.5rem;
    transform: translateX(-50%);
    color: #fff;
    background: rgba(#000, 0.8);
    font-weight: bolder;
    padding: 0.5em 1em;
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/UserAction/PauseController.vue